import gql from 'graphql-tag';

export const mutationDeleteIntegration = gql`
  mutation deleteIntegration (
    $id: DokkioID!
  ) {
    deleteIntegration (
      id: $id
    )
  }
`;
export default mutationDeleteIntegration;
